import '../pages/CoreUserTaskFeedback/store/init';
import '../pages/CoreUserTaskTimeTracking/store/init';

import { fetchCoreUser, fetchCoreUserOccupancy } from './effects';
import { $coreUser, $coreUserOccupancy } from './states';

// Fetch core user
$coreUser.on(fetchCoreUser.doneData, (_, data) => data);

// Fetch core user
$coreUserOccupancy.on(fetchCoreUserOccupancy.doneData, (_, data) => data);
